import { GlobalService } from './../../services/global.service';
import { AuthService } from './../../services/auth.service';
import { LoadingService } from './../../services/loading.service';
import { HelperService } from './../../services/helper.service';
import { Usuario } from './../../models/usuario.model';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-reset-password',
  templateUrl: './modal-reset-password.component.html',
  styleUrls: ['./modal-reset-password.component.scss']
})
export class ModalResetPasswordComponent {

  user: Usuario = new Usuario();
  codigo: string = '';
  loading: boolean = false;

  constructor(
    public helper: HelperService,
    public loadingService: LoadingService,
    public auth: AuthService,
    public http: HttpClient,
    public global: GlobalService,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalResetPasswordComponent>) {
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  // A API nova troca a senha com o codigo de verificacao enviado por e-mail
  // (/auth/create dispara o codigo, /auth/update-password consome).
  recuperarSenha() {

    if (!this.codigo) {
      this.helper.openSnackBar('Informe o codigo que enviamos por e-mail.');
      return;
    }

    if (!this.user.senha || this.user.senha !== this.user.re_senha) {
      this.helper.openSnackBar('As senhas não coincidem.');
      return;
    }

    const email = (this.data && this.data.email) ? this.data.email : (this.auth.user ? this.auth.user.email : '');

    if (!email) {
      this.helper.openSnackBar('Nao foi possivel identificar o e-mail da conta.');
      return;
    }

    this.loadingService.present('Alterando a senha...');

    this.auth.updatePassword(email, this.user.senha, this.codigo)
      .then(() => {
        // a API derruba as sessoes ao trocar a senha, entao o login e refeito na tela
        this.auth.logout();
        this.loadingService.dismiss();
        this.dialogRef.close(true);
      })
      .catch((e) => {
        this.helper.openSnackBar(e.error ? e.error : 'Codigo invalido ou expirado.');
        this.loadingService.dismiss();
      });
  }

}
